import { GARSON_BRAND } from './assets';

/** Persian-first vector lockup; the letterforms never depend on loaded fonts. */
export function Logo({
  size = 36,
  showWordmark = true,
  inverse = false,
}: {
  size?: number;
  showWordmark?: boolean;
  inverse?: boolean;
}) {
  return (
    <span
      role="img"
      aria-label="گارسون"
      dir="rtl"
      data-garson-logo
      style={{ display: 'inline-flex', alignItems: 'center', gap: size * 0.28, flex: 'none', verticalAlign: 'middle' }}
    >
      <img
        src={inverse ? GARSON_BRAND.markInverse : GARSON_BRAND.mark}
        alt=""
        aria-hidden="true"
        width={size}
        height={size}
        style={{ flex: 'none', display: 'block' }}
      />
      {showWordmark && (
        <img
          src={inverse ? GARSON_BRAND.wordmarkInverse : GARSON_BRAND.wordmark}
          alt=""
          aria-hidden="true"
          width={size * 1050 / 382}
          height={size}
          style={{ flex: 'none', display: 'block' }}
        />
      )}
    </span>
  );
}
